import { create } from 'zustand';
import { IInterestStore } from 'types/stores';

export const useInterestsStore = create<IInterestStore>(() => ({
  interests: [],
}));
